import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=202bc6a7&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"
import style0 from "./dashboard.css?vue&type=style&index=0&id=202bc6a7&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202bc6a7",
  null
  
)

export default component.exports